import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureReviewInvoicing(): boolean {
  return useFeatureEnabled('REVIEW_INVOICING');
}
